import { pacingTypes } from '../../../../../../../../../../configs';
import type { MultipleEditDrawerLineItemsFormValues } from '../../../../../../types';
import type { BufferConflictIdsResult } from '../../checkConflictsAndWarnings/checkBufferConflicts/checkBufferConflicts';

type Props = {
  values: MultipleEditDrawerLineItemsFormValues;
  bufferConflicts?: BufferConflictIdsResult | null;
  isLineItem: boolean;
};

type BufferValue = {
  id: string;
  value: number | null;
}[];

type AutomateBufferValue = {
  id: string;
  value: boolean;
}[];

type Result = {
  buffer?: {
    buffer?: BufferValue;
    frontload?: BufferValue;
    automateBuffer?: AutomateBufferValue;
  };
};

export const getPreparedInputForBuffer = ({ values, bufferConflicts, isLineItem }: Props): Result => {
  const frontloadPercent = values.buffer.frontLoadPercent;
  const isFrontloadPercentSet = frontloadPercent != null;

  const isBufferSelected = values.selectedSections.includes('Buffer');
  const isFrontloadSelected = values.selectedSections.includes('Frontload');

  if (!isLineItem || (!isBufferSelected && !isFrontloadSelected)) {
    return {};
  }

  const entitiesWithBufferUpdates = values.entities.filter(
    (entity) =>
      entity.pacingType?.key !== pacingTypes.SOV.key && !bufferConflicts?.bufferConflictIds.includes(entity.id)
  );

  const lineItemsWithUpdateBuffer = isBufferSelected
    ? {
        buffer: entitiesWithBufferUpdates
          .filter((entity) => entity.deliveryBufferPercent != null && !entity.automateBuffer)
          .map((entity) => ({
            id: entity.id,
            value: entity.deliveryBufferPercent!,
          })),
        automateBuffer: entitiesWithBufferUpdates.map((entity) => ({
          id: entity.id,
          value: entity.automateBuffer ?? false,
        })),
      }
    : {};

  const lineItemsWithUpdateFrontload =
    isFrontloadSelected && isFrontloadPercentSet
      ? {
          frontload: values.entities
            .filter(
              (entity) =>
                entity.pacingType?.key !== pacingTypes.SOV.key &&
                !bufferConflicts?.frontloadConflictIds.includes(entity.id)
            )
            .map((entity) => ({
              id: entity.id,
              value: frontloadPercent,
            })),
        }
      : {};

  return {
    buffer: {
      ...lineItemsWithUpdateBuffer,
      ...lineItemsWithUpdateFrontload,
    },
  };
};
